import { APIError } from './apiError';

class LoginError extends APIError {}

export { LoginError };
export default LoginError;
